import { cn } from '@/lib/utils';

const BASE_CLASS = 'mm-skeleton';

function Skeleton({ className, ...props }: React.ComponentProps<'div'>) {
  return (
    <div
      data-slot="skeleton"
      className={cn(
        BASE_CLASS,
        'animate-pulse rounded-md bg-primary/10 brutalist:rounded-xs',
        className
      )}
      {...props}
    />
  );
}

export { Skeleton };
